<!-- =========================================================================================
  File Name: FrequencyCreate.vue
  Description: Frequency Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="frequencyCreatePermission" id="page-user-edit">
		<vx-card>
			<frequency-create-tab class="mt-4" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import FrequencyCreateTab from "@/components/frequency/create/FrequencyCreateTab.vue";

export default {
	components: {
		NotPermission,
		FrequencyCreateTab,
	},
	computed: {
		frequencyCreatePermission() {
			return this.$store.getters.checkPermission("FREQUENCY_C");
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
